import { render, staticRenderFns } from "./BeginTask.vue?vue&type=template&id=95f9a9f4&"
import script from "./BeginTask.vue?vue&type=script&lang=js&"
export * from "./BeginTask.vue?vue&type=script&lang=js&"
import style0 from "./BeginTask.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports